import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
export function AnnouncementBar() {
  const {
    t
  } = useLanguage();
  return <div className="bg-royal text-white" data-id="element-32" data-mp="jt20hy305c3p">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-4 py-2 text-center" data-id="element-33" data-mp="jrqurspzxu9y">
        <SparklesIcon className="hidden h-4 w-4 shrink-0 text-aqua sm:block" aria-hidden="true" data-id="element-34" data-mp="et63wjwmwmy6" />
        <p className="text-xs font-medium sm:text-sm" data-id="element-35" data-mp="9tkvlivkr28s">{t(copy.announcement)}</p>
      </div>
    </div>;
}